import { styled } from '@mui/material'

export const PlayerSectionContainer = styled('div')`
  flex: 0.6;
  padding: 20px 0 20px 20px;
  min-width: 426px;
`

export const LoadingText = styled('span')`
  position: absolute;
  top: 50%;
  left: 50%;
`

export const PlayerContainer = styled('div')`
  background: black;
  height: auto;
  width: 100%;
  vertical-align: baseline;
  margin: 0;
  border: 0;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 56.25%;
  box-shadow: rgb(0 27 45 / 50%) 0 8px 16px;
`
